import React from "react";
import { useMediaQuery } from "react-responsive";

interface IResponsive {
  children: React.ReactNode;
}

const useIsDesktop = () => useMediaQuery({ minWidth: 992 });

const Desktop = ({ children }: IResponsive) => {
  const isDesktop = useIsDesktop();
  return <>{isDesktop && children ? children : null}</>;
};

const useIsTablet = () => useMediaQuery({ minWidth: 768, maxWidth: 991 });

const Tablet = ({ children }: IResponsive) => {
  const isTablet = useIsTablet();
  return <>{isTablet && children ? children : null}</>;
};

const useIsMobile = () => useMediaQuery({ maxWidth: 767 });

const Mobile = ({ children }: IResponsive) => {
  const isMobile = useIsMobile();
  return <>{isMobile && children ? children : null}</>;
};

const useIsDefault = () => useMediaQuery({ minWidth: 768 });

const Default = ({ children }: IResponsive) => {
  const isNotMobile = useIsDefault();
  return <>{isNotMobile && children ? children : null}</>;
};

const useIsLaptop = () =>
  useMediaQuery({
    query:
      "(min-device-width: 1200px) and (max-device-width: 1600px) and (-webkit-min-device-pixel-ratio: 1)",
  });

const useIsFHD = () =>
  useMediaQuery({
    deviceWidth: 1920,
    deviceHeight: 1080,
  });

const Laptop = ({ children }: IResponsive) => {
  const isNotLaptop = useIsLaptop();
  return <>{isNotLaptop && children ? children : null}</>;
};

const useIsRetina = () =>
  useMediaQuery({
    query:
      "(min-device-width: 1200px) and (max-device-width: 1600px) and (-webkit-min-device-pixel-ratio: 2) and (min-resolution: 192dpi)",
  });

const useIs4K = () => useMediaQuery({ minWidth: 3800, minHeight: 2100 });

export {
  useIsDesktop,
  Desktop,
  useIsTablet,
  Tablet,
  useIsMobile,
  Mobile,
  useIsDefault,
  Default,
  useIsLaptop,
  Laptop,
  useIsRetina,
  useIs4K,
  useIsFHD,
};
